export default "__VITE_ASSET__D1CPv0F6__"